import '@hotwired/turbo-rails';
import { Application } from '@hotwired/stimulus';
import { AccordionController } from '@inked/accordion';
import { AddressController } from '@inked/address';
import { AriaController } from '@inked/aria';
import { CharacterCounterController } from '@inked/character-counter';
import { CloudflareTurnstileController } from '@inked/cloudflare-turnstile';
import { ConsentController } from '@inked/consent';
import { CountdownController } from '@inked/countdown';
import { DataLayerController } from '@inked/data-layer';
import { DialogController } from '@inked/dialog';
import { DropdownMenuController } from '@inked/dropdown-menu';
import { EventController } from '@inked/event';
import { FaqController } from '@inked/faq';
import { FieldController } from '@inked/field';
import { FocusStealController } from '@inked/focus-steal';
import { MarqueeController } from '@inked/marquee';
import { PopoverController } from '@inked/popover';
import { TextareaController } from '@inked/textarea';
import { TimeZoneController } from '@inked/time-zone';
import { VideoController } from '@inked/video';
import { InkedSubmarkController } from './inked-submark';

Turbo.session.drive = false;

const app = Application.start();

app.debug = process.env.NODE_ENV !== 'production';

app.register('accordion', AccordionController);
app.register('address', AddressController);
app.register('aria', AriaController);
app.register('character-counter', CharacterCounterController);
app.register('cloudflare-turnstile', CloudflareTurnstileController);
app.register('consent', ConsentController);
app.register('countdown', CountdownController);
app.register('data-layer', DataLayerController);
app.register('dialog', DialogController);
app.register('dropdown-menu', DropdownMenuController);
app.register('event', EventController);
app.register('faq', FaqController);
app.register('field', FieldController);
app.register('focus-steal', FocusStealController);
app.register('inked-submark', InkedSubmarkController);
app.register('marquee', MarqueeController);
app.register('popover', PopoverController);
app.register('textarea', TextareaController);
app.register('time-zone', TimeZoneController);
app.register('video', VideoController);
